// constants.js
export const CELL_TYPE_TRANSLATION = {
  'squamous': '鳞状上皮细胞',
  'squamous-lsil': '低级别鳞状上皮内病变',
  'squamous-hsil': '高级别鳞状上皮内病变',
  'squamous-asc-us': '非典型鳞状上皮细胞-意义不明确',
  'squamous-asc-h': '非典型鳞状上皮细胞-不除外高级别鳞状上皮内病变',
  'squamous-sqcac': '鳞状细胞癌',
  'Lsi1-1(团)': '成团的低级别（包括非典型鳞状、低度病变）',
  'Hsi1-1（团）': '成团的高级别（包括非典型不除外高、高度病变、癌细胞）',
  'squamous-pm-two（团）': '萎缩（成团）',
  'squamous-repair（团）': '修复（成团）',
  'b1': '线素细胞/细菌性阴道病',
  'b2': '放线菌',
  'm1': '霉菌/真菌/白色念珠菌/念珠菌',
  'm2': '孢子',
  't1': '滴虫',
  'hsv': '人类单纯疱疹病毒',
  'ascus-cell': '介于正常细胞与ASCUS之间',
  'glandular-adcae': '腺细胞异常',
  'normal': '正常',
  'glandular': '正常腺细胞',
  'r': '放疗',
  'ascus-h-cell': '介于正常与ASCUS-n之间',
  'other': '杂质',
  'em': '子宫内膜细胞',
  'squamous-pm': '萎缩细胞',
  'squamous-metaplastic': '‌鳞状化生细胞',
};

export const CELL_TYPE_COLORS = {
  'squamous': '#f022a5',
  'squamous-lsil': '#f1c40f',
  'squamous-hsil': '#e74c3c',
  'squamous-asc-us': '#9b59b6',
  'squamous-asc-h': '#e67e22',
  'squamous-sqcac': '#c0392b',
  // 其他类型颜色...
  'default': '#2ecc71'
};